import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";
import apiResponse from "../../../../services/apiResponse";
import SubmissionBloc from "./Blocs/SubmissionBloc";
import { accessRole } from "../../../../helpers/access_role";
import { withRouter } from "react-router";

class IndexView extends Component {
  submitssionBloc = new SubmissionBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
    };
  }

  submitData = async () => {
    await this.submitssionBloc.fetchSubmit(this.state.dataForm);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.submitssionBloc.submitChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.submitssionBloc.submitChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card className="">
                <CardBody>
                  <CardTitle>Tambah Pengajuan Usulan Pemberhentian</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Periode Awal<span className="text-danger">*</span>
                      </label>
                      <Col md="2">
                        <AvField
                          name="emp_retired_submission_date_start"
                          placeholder="Periode Awal..."
                          type="date"
                          errorMessage="Masukkan Periode Awal"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="emp_retired_submission_date_start"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Periode Akhir<span className="text-danger">*</span>
                      </label>
                      <Col md="2">
                        <AvField
                          name="emp_retired_submission_date_end"
                          placeholder="Periode Akhir..."
                          type="date"
                          errorMessage="Masukkan Periode Akhir"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="emp_retired_submission_date_end"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="" className="col-md-3 col-form-label">
                        Keterangan <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="emp_retired_submission_description"
                          placeholder="Keterangan..."
                          type="textarea"
                          errorMessage="Keterangan"
                          className="form-control"
                          rows="8"
                          validate={{ required: { value: true } }}
                          id="emp_retired_submission_description"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="/kepegawaian/pensiun.html">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan dan
                          Ajukan
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin mengajukan data ini akan ?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil diajukan"
          failedTitle="Gagal!"
          failedInfo="Data gagal diajukan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/pensiun.html" />
        ) : null}
      </Fragment>
    );
  }
}

export default withRouter(IndexView);
